import { render, staticRenderFns } from "./NavigatorSlotDemo.vue?vue&type=template&id=0cdbf322&scoped=true"
import script from "./NavigatorSlotDemo.vue?vue&type=script&lang=js"
export * from "./NavigatorSlotDemo.vue?vue&type=script&lang=js"
import style0 from "./NavigatorSlotDemo.vue?vue&type=style&index=0&id=0cdbf322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdbf322",
  null
  
)

export default component.exports